import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CodeSandboxSquareFilledSvg from "@ant-design/icons-svg/es/asn/CodeSandboxSquareFilled";
import AntdIcon from "../components/AntdIcon";
var CodeSandboxSquareFilled = function CodeSandboxSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodeSandboxSquareFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CodeSandboxSquareFilled.displayName = 'CodeSandboxSquareFilled';
}
export default /*#__PURE__*/React.forwardRef(CodeSandboxSquareFilled);